import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconDropdownSelected} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal,Select, Tag,Popover} from "antd";
import {t} from "i18next";
import {
    generateUUID2,
} from "../../utils";
import {deleteView, updateView} from "@model/view";
import {postMessage} from "@/common/event";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

const DialogAddView = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const txtNameRef = useRef(null);

    const [property,setProperty] = useState<any>(null);
    const [arrayPropertyType,setArrayPropertyType] = useState<any>([]);
    const [isNew,setIsNew] = useState(true);
    const [isEnabledSelected,setIsEnabledSelected] = useState(true);
    const mCallback = useRef<any>(null);
    const mLastViewRef = useRef<any>(null);

    const ARRAY_DEFAULT_VIEW = [
        {
            value:'tableView',
            label:t('Table view')
        },
        {
            value:'gridView',
            label:t('Grid view')
        }
    ]

    useEffect(() => {
        setArrayPropertyType(ARRAY_DEFAULT_VIEW);
    }, []);


    useEffect(() => {
        document.body.addEventListener('keydown',onKeyDown);
        return ()=>{
            document.body.removeEventListener('keydown',onKeyDown);
        }
    });

    function onKeyDown(event){
        if (event.key == KEYS.ENTER){
            onConfirm();
        }
    }

    const onShowDialog = (view:any,tagName:any,callback:any,lastView:any)=>{
        setIsShowDialog(true);
        mCallback.current = callback;
        mLastViewRef.current = lastView;
        if (view){
            setProperty(view);
            setIsNew(false);
        }else{
            setProperty({...ARRAY_DEFAULT_VIEW[0],id:generateUUID2(),tagName:tagName});
        }
        setTimeout(()=>{
            txtNameRef.current?.focus();
        },200)
    }

    const onConfirm = ()=>{
        if (!property.name) {
            message.destroy();
            message.error(t('PleaseEnterTheName'));
            return;
        }
        //保存.
        const newProperty = {...property};
        if (!newProperty.type){
            newProperty.type = newProperty.value;
        }
        newProperty.updateTime = Date.now();
        newProperty.viewSort = 100;
        if (mLastViewRef.current?.columns){
            newProperty.columns = mLastViewRef.current.columns;
        }
        if (!newProperty.columns)
        {
            newProperty.columns = [{
                id: 'name',
                name:'Name',
                icon:'property_text',
            }]
        }

        updateView(newProperty).then(res=>{
            props.onCloseCallback();
            //刷新列表
            window.globalRefreshList('refresh_tag_view_list_',isNew?newProperty:null);
        })
    }


    // @ts-ignore
    return <Modal width={520} zIndex={2005} bodyStyle={{}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{isNew ? t('Add view') : t('Edit view')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'mt-12'}>{t("View type")}</span>
            <Select className={'mt-10'}
                    disabled={!isEnabledSelected}
                    dropdownClassName={'shadow'}
                    value={property?.value}
                    labelInValue={true}
                    options={arrayPropertyType}
                    suffixIcon={<IconDropdownSelected/>} onChange={(e) => {
                        const view = {...property};
                        view.type = view.value = e.value;
                setProperty(view);
            }}/>


            <span className={'mt-18'}>{t("View name")}</span>
            <input ref={txtNameRef} className={'input-border mt-10'} placeholder={t('PleaseEnterTheName')}
                   value={property?.name} onInput={(e) => {
                const newLink = {...property};
                newLink.name = e.currentTarget.value;
                setProperty(newLink);
            }}/>


            <div className={'flex-center mt-22 mb-4'}>

                {
                    !isNew &&
                    <>
                        <div
                            style={{height: '34px', minWidth: '120px',cursor:property?.id !== 'defaultView'?'pointer':'not-allowed'}}
                            className={`large-w-button font-size-14 font-family-medium flex-center ${property?.id == 'defaultView'?'button-solid-disable':'button-solid-style-delete'}`}
                            onClick={() => {
                                if (property?.id == 'defaultView') {
                                    return;
                                }
                                window.showMessageBox(t("Delete view"),t("SureToDeleteView"),t('Cancel'),t('Delete'),null,()=>{
                                    //删除并关闭
                                    deleteView(property?.id).then(res=>{
                                        //刷新.
                                        props.onCloseCallback();
                                        //刷新列表
                                        window.globalRefreshList('refresh_tag_view_list_');
                                    })
                                })
                            }}>{t("Delete")}</div>

                        <div style={{flexGrow: '1'}}></div>
                    </>
                }


                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        onConfirm();
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})


export default DialogAddView;

